const All_PASSANGER_TYPES={
  ALL_PASSANGER_INFO_FETCHING_START: 'ALL_PASSANGER_INFO_FETCHING_START',
  ALL_PASSANGER_INFO_FETCHING_FAILURE:'ALL_PASSANGER_INFO_FETCHING_FAILURE',
  ALL_PASSANGER_INFO_FETCHING_SUCCESS: 'ALL_PASSANGER_INFO_FETCHING_SUCCESS',
  REMOVE_FETCHED_PASSENGERS:  'REMOVE_FETCHED_PASSENGERS',
  SET_SELECTED_PASSENGER_SEAT_NO:'SET_SELECTED_PASSENGER_SEAT_NO',
  REMOVE_SELECTED_PASSENGER_SEAT_NO: 'REMOVE_SELECTED_PASSENGER_SEAT_NO',
  SELECT_NEW_SEAT:'SELECT_NEW_SEAT',
  CLEAR_NEW_SEAT:'CLEAR_NEW_SEAT',
  CHANGE_DISPLAY_BUTTON_NEXT:'CHANGE_DISPLAY_BUTTON_NEXT',
  PNR_PASSENGER_INFO_FETCHING_START:'PNR_PASSENGER_INFO_FETCHING_START',
  PNR_PASSENGER_INFO_FETCHING_SUCCESS: 'PNR_PASSENGER_INFO_FETCHING_SUCCESS',
  PNR_PASSENGER_INFO_FETCHING_FAILURE: 'PNR_PASSENGER_INFO_FETCHING_FAILURE',
  PNR_PASSENGER_INFO_FETCHING_REMOVE: 'PNR_PASSENGER_INFO_FETCHING_REMOVE',
  ADD_PASSANGER_PNR_TO_REDUCER: 'ADD_PASSANGER_PNR_TO_REDUCER',
  SEAT_UPDATE_START_FOR_CREW_LOGED_IN: 'SEAT_UPDATE_START_FOR_CREW_LOGED_IN',
  SEAT_UPDATE_SUCCESS_FOR_CREW_LOGED_IN: 'SEAT_UPDATE_SUCCESS_FOR_CREW_LOGED_IN',
  SEAT_UPDATE_FAILURE_FOR_CREW_LOGED_IN: 'SEAT_UPDATE_FAILURE_FOR_CREW_LOGED_IN',
  SET_CREW_VIEW: 'SET_CREW_VIEW'

}

export default All_PASSANGER_TYPES;